import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledPartners = styled('div')`
  .ant-table-cell.centered-column {
    text-align: center;
  }

  .ant-table-cell::before {
    content: none !important;
    border: none !important;
    display: none !important;
  }

  .ant-checkbox-wrapper-disabled {
    cursor: default;
  }

  .ant-checkbox-wrapper-disabled
    .ant-checkbox-input:checked
    + .ant-checkbox-inner {
    border-color: ${(props) => props.theme.checkboxInner};
    background-color: ${(props) => props.theme.checkboxInner};
    color: ${(props) => props.theme.backgroundInput};
  }

  .ant-checkbox-wrapper-disabled .ant-checkbox-inner::after {
    border-color: ${(props) => props.theme.backgroundInput};
  }

  .partners {
    height: 115px;
    background-color: ${(props) => props.theme.filterBackground};
    padding: 0 20px;

    label {
      bottom: -10px;
    }

    .under-text {
      position: relative;
      top: -18px;
      font-size: 14px;
      color: ${(props) => props.theme.underTextColor};
      z-index: 3;
    }
  }

  .actions-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .actions-title {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .inbound {
    display: flex;
    gap: 15px;
  }

  .underline {
    text-decoration: underline;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .partners {
      padding: 0;
      margin-bottom: 16px;
    }
    .ant-tabs-nav::before {
      display: none;
    }
    .ant-tabs-nav {
      margin: 16px 0 16px 0;
      .ant-tabs-nav-list {
        display: none !important;
      }
    }
    .separator {
      margin: 32px 0 32px 0;
      border-bottom: 1px solid ${(props) => props.theme.inputAddonBg};
      width: 100;
    }
  }
`;
